import Vue from 'vue'

import Vant from 'vant';
import 'vant/lib/index.css';

import Index from './Index'
import router from './router'
import t from './components/t'
import passwordBox from './components/password-box'
import statsHeader from './components/stats-header'
import userBox from './components/user-box'
import sideMenu from './components/side-menu'
import { ImagePreview } from 'vant';
Vue.use(ImagePreview);

import 'animate.css';
import '@vant/touch-emulator';

import {
  Locale
} from 'vant';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import img2 from './components/img2.vue';

const messages = {
  'en-US': {
    vanCalendar: {
      monthTitle: (year, month) => {
        let arr = [
          '一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'
        ];
        return year + '  ' + arr[month - 1];
      },
      weekdays: ['日', '月', '火', '水', '木', '金', '土'],
    },
  },
};

Locale.use('en-US', enUS);
Locale.add(messages);

Vue.use(Vant);
import TextareaAutosize from 'vue-textarea-autosize'
Vue.use(TextareaAutosize);
Vue.component('t', t);
Vue.component('userBox', userBox);
Vue.component('sideMenu', sideMenu);
Vue.component('passwordBox', passwordBox);
Vue.component('statsHeader', statsHeader);
Vue.component('img2', img2);
Vue.config.productionTip = false

window.B = {};

window.S = {
  'set': function (key, value) {

    if (typeof (value) == 'object')
      value = JSON.stringify(value);

    localStorage.setItem(key, value);

  },
  'get': function (key) {
    var value = localStorage.getItem(key);

    try {
      return JSON.parse(value);
    } catch (ex) {
      return value;
    }
  },
  'remove': function (key) {
    if (typeof key == 'object' && key.hasOwnProperty('length'))
      for (var i = 0; i < key.length; i++) {
        localStorage.removeItem(key[i]);
      }
    else
      localStorage.removeItem(key);
  },
  'clear': function () {
    var data = getFields(localStorage, ['lang'], false);
    clearLocalStorage();
    for (var name in data) {
      localStorage.setItem(name, data[name]);
    }
  }
};

window.A = {
  'show': function (body, title, type) {
    return Swal.mixin({
      customClass: {
        confirmButton: 'btn-lg btn-orange',
        cancelButton: 'btn-sm btn-dark mr10'
      },
      confirmButtonText: Vue.prototype.t('確認'),
      showCancelButton: false,
      buttonsStyling: false,
    }).fire(title, body, type || '');
  },
  'err': function (body, title) {
    return Swal.mixin({
      customClass: {
        confirmButton: 'btn-lg btn-orange',
        cancelButton: 'btn-sm btn-dark mr10'
      },
      confirmButtonText: Vue.prototype.t('確認'),
      showCancelButton: false,
      buttonsStyling: false,
    }).fire(title, body, 'error');
  },
  'toast': function (text, duration, type) {
    return Swal.mixin({
      timer: duration || 1000,
      timerProgressBar: true,
      buttonsStyling: false,
      showCancelButton: false,
      showConfirmButton: false
    }).fire(text, '', type || 'success');
  },
  'safety': function (content, type, onlyAlert) {

    return Swal.mixin({
      customClass: {
        confirmButton: 'btn-lg btn-orange',
        cancelButton: 'btn-sm btn-dark mr10'
      },
      confirmButtonText: Vue.prototype.t('確認'),
      cancelButtonText: Vue.prototype.t('取消'),
      buttonsStyling: false,
      showCancelButton: !onlyAlert
    }).fire(Vue.prototype.t('内容確認'), content, type || 'warning');

  }
};

Date.prototype.format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    'S': this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
  return fmt;
};

Date.today = function () { return new Date(new Date().format('yyyy/MM/dd')) };

Array.prototype.clear = function () {
  this.length = 0;
};

Array.prototype.remove = function (item) {
  var index = this.indexOf(item);
  if (index > -1)
    this.splice(index, 1);
  return this;
};

Array.prototype.removeAll = function (items) {

  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var index = this.indexOf(item);
    if (index > -1)
      this.splice(index, 1);
  }
  return this;
};

Array.prototype.append = function (items) {
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var index = this.indexOf(item);
    if (index < 0)
      this.push(item);
  }
  return this;
};

window.getFields = function (model, fields, isInclude) {
  isInclude = isInclude == undefined ? true : isInclude;

  var result = {};

  if (isInclude) {
    for (var i = 0; i < fields.length; i++) {

      var field = fields[i];

      if (typeof field == "string") {
        if (model[field] != null)
          result[field] = model[field];
      } else if (typeof field == "object") {
        for (var source in field) {
          var fieldName = field[source];
          result[fieldName] = model[source];
          break;
        }
      }
    }
  } else {
    for (var name in model) {

      var value = model[name];

      if (fields.indexOf(name) < 0 && value != null)
        result[name] = value;

    }
  }

  return result;
}

window.listToDict = function (list, keyName) {

  keyName = keyName || 'id';

  var dict = {};

  if (list && list.length > 0) {
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      dict[item[keyName]] = item;
    }
  }

  return dict;

}

window.listToDict2 = function (list, keyName, valueName) {

  keyName = keyName || 'id';

  var dict = {};

  if (list && list.length > 0) {
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      dict[item[keyName]] = item[valueName];
    }
  }

  return dict;

}

window.mirror = function (source, target) {

  target = target || {};

  for (var name in source) {
    target[name] = source[name];
  }

  return target;
}


window.mirrorSet = function (source, target) {

  target = target || {};

  for (var name in source) {
    Vue.set(target, name, source[name]);
  }

  return target;
}

window.mirror2 = function (source, target) {

  target = target || {};

  for (var name in target) {
    target[name] = source[name];
  }

  return target;
}

window.combineObject = function (o1, o2) {
  var r = {};

  for (var key in o1) {
    r[key] = o1[key];
  }

  for (var key in o2) {
    r[key] = o2[key];
  }

  return r;
}

window.getURLParams = function () {

  var r;
  if (location.search && location.search.indexOf('?') > -1) {

    r = location.search.split('?')[1].split('&');

  }

  if (location.hash && location.hash.indexOf('?') > -1) {

    r = location.hash.split('?')[1].split('&');

  }

  var obj = {};

  if (r && r.length > 0) {

    r.forEach(function (item) {
      var _tmp = item.split('=');
      obj[_tmp[0]] = _tmp[1];
    });

    return obj;
  }



  return {};

}

window.compressImg = function (file, options, callback) {
  var imgname = file.name;
  var imgtype = (imgname.substring(imgname.lastIndexOf('.') + 1)).toLowerCase();
  if (imgtype == 'jpg' || imgtype == 'jpeg') {
    imgtype = 'image/jpeg';
  } else {
    imgtype = 'image/png';
  }
  // 用FileReader读取文件
  var reader = new FileReader();
  // 将图片读取为base64
  reader.readAsDataURL(file);
  reader.onload = function (evt) {
    var base64 = evt.target.result;
    window._compressImg(base64, options, callback, imgtype);
  }
};
window._compressImg = function (base64, options, callback, imgtype) {
  imgtype = imgtype || 'image/png';
  // 创建图片对象
  var img = new Image();
  // 用图片对象加载读入的base64
  img.src = base64;



  img.onload = function () {
    var that = this,
      canvas = document.createElement('canvas'),
      ctx = canvas.getContext('2d');

    var maxWidth = options.max_width;
    var maxHeight = options.max_height;

    var targetWidth, targetHeight;

    if (img.width > maxWidth && img.height > maxHeight) {
      const rate = Math.min(maxWidth / img.width, maxHeight / img.height)
      targetWidth = img.width * rate
      targetHeight = img.height * rate
    } else if (img.width > maxWidth) {
      targetWidth = maxWidth
      targetHeight = (maxWidth / img.width) * img.height
    } else if (img.height > maxHeight) {
      targetHeight = maxHeight
      targetWidth = (maxHeight / img.height) * img.width
    } else {
      targetWidth = img.width
      targetHeight = img.height
    }

    canvas.setAttribute('width', targetWidth);
    canvas.setAttribute('height', targetHeight);
    // 将图片画入canvas
    ctx.drawImage(that, 0, 0, targetWidth, targetHeight);

    // 压缩到指定体积以下（M）
    if (options.size) {
      var scale = 0.9;
      (function f(scale) {
        if (base64.length / 1024 / 1024 > options.size && scale > 0) {
          base64 = canvas.toDataURL(imgtype, scale);
          scale = scale - 0.1;
          f(scale);
        } else {
          callback(base64, canvas);

        }
      })(scale);
    } else if (options.scale) {
      // 按比率压缩
      base64 = canvas.toDataURL(imgtype, options.scale);
      callback(base64, canvas);
    } else if (options.max_height || options.max_height) {
      base64 = canvas.toDataURL(imgtype, 1);
      callback(base64, canvas);
    }

  }
}

window.getObjectURL = function (file) {
  var url = null;
  if (window.createObjectURL != undefined) { //basic
    url = window.createObjectURL(file);
  } else if (window.URL != undefined) { //mozilla(firefox)兼容火狐
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL != undefined) { //webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}

window.filter = function (arr, fn) {
  var res = [];
  for (var i = 0; i < arr.length; i++) {
    if (fn(arr[i]))
      res.push(arr[i]);
  }
  return res;
}

window.pluck = function (items, key) {
  var arr = [];
  for (var i = 0; i < items.length; i++) {
    arr.push(items[i][key]);
  }
  return arr;
}

window.pick = function (items, fields) {
  var arr = [];
  for (var i = 0; i < items.length; i++) {
    let item = {};
    for (var j = 0; j < fields.length; j++) {
      item[fields[j]] = items[i][fields[j]];
    }
    arr.push(item);
  }
  return arr;
}

window.copyFrom = function (source, target) {
  for (const key in source) {
    source[key] = target[key];
  }
}

window.addMonthsToDate = function (date, months) {
  // 获取日期的年份和月份
  var year = date.getFullYear();
  var month = date.getMonth();

  // 计算新的月份和年份
  var newMonth = month + months;
  var newYear = year;

  // 如果新月份小于0，需要调整年份和月份
  if (newMonth < 0) {
    // 计算需要减去多少年
    var yearsToSubtract = Math.floor(Math.abs(newMonth) / 12);
    newYear -= yearsToSubtract;
    // 更新月份，注意月份是从0开始的，所以这里使用负数
    newMonth += yearsToSubtract * 12;
  }

  // 创建一个新的日期对象
  var newDate = new Date(newYear, newMonth, 1);

  // 如果原始日期的天数大于新月份的天数，则将日期设置为新月份的最后一天
  if (date.getDate() > new Date(newYear, newMonth + 1, 0).getDate()) {
    newDate = new Date(newYear, newMonth, new Date(newYear, newMonth + 1, 0).getDate());
  }

  return newDate;
}

window.getDaysInMonth = function (year, month) {
  // 注意：JavaScript中的月份是从0开始的，即0代表1月，11代表12月
  month = month - 1; // 调整月份以适应JavaScript的月份计数方式

  // 创建一个日期对象，设置为指定年份和月份的第一天
  var date = new Date(year, month, 1);

  // 获取下个月的第一天
  var nextMonth = new Date(year, month + 1, 1);

  // 计算两个日期之间的天数差，即为该月的天数
  var days = (nextMonth - date) / (1000 * 60 * 60 * 24);

  return days;
}

window.getDaysDiff = function (date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // 验证日期是否有效
  if (isNaN(d1) || isNaN(d2)) {
    throw new Error('Invalid date input');
  }

  const time1 = d1.getTime();
  const time2 = d2.getTime();

  const timeDifference = time2 - time1;
  const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

  return Math.floor(daysDifference);
}

window.getMinutesDiff = function (date1, date2) {
  const differenceInMilliseconds = date2 - date1;

  const differenceInMinutes = differenceInMilliseconds / (1000 * 60);

  return differenceInMinutes;
}

window.clearLocalStorage = function (keysToKeep) {

  const regexKeep = /chatLang/gi;
  const allKeys = Object.keys(localStorage);

  if (keysToKeep) {
    allKeys.forEach(key => {
      if (keysToKeep.indexOf(key) < 0) {
        localStorage.removeItem(key);
      }
    });
  } else {
    allKeys.forEach(key => {
      if (regexKeep.test(key) == false) {
        localStorage.removeItem(key);
      }
    });
  }
}


window.ImageUploader = {
  'openSelector': function (multiple) {
    var fImage = document.getElementById('fImage');
    fImage.removeAttribute('capture');
    fImage.value = '';
    if (multiple)
      fImage.multiple = true;
    else
      fImage.multiple = false;

    fImage.click();
  },
  'openCamera': function () {
    var fImage = document.getElementById('fImage');
    fImage.setAttribute('capture', 'environment');
    fImage.multiple = false;
    fImage.click();
  },
  'onSelectFile': function () {

    var inputFile = window.event.target;

    var file = inputFile.files[0];

    if (!file)
      return;

    if (file.type.match('image.*')) {
      if (ImageUploader.onSelectImage)
        ImageUploader.onSelectImage(file);

      if (ImageUploader.onSelectImages)
        ImageUploader.onSelectImages(inputFile.files);
    } else {

    }
    inputFile.value = '';
  },
  'onSelectImage': function () {

  },
  'onSelectImages': function () {

  }
};

window.FileUploader = {
  'openSelector': function (multiple) {
    var fFile = document.getElementById('fFile');
    if (multiple)
      fFile.multiple = true;
    else
      fFile.multiple = false;

    fFile.click();
  },

  'selectFile': function () {

    var inputFile = window.event.target;

    var file = inputFile.files[0];

    if (!file)
      return;

    FileUploader.onSelectFile(file);

    inputFile.value = '';
  },
  'onSelectFile': function (file) {

  }
};

Vue.prototype.url = function (url) {
  if (!url)
    return url;
  if (url.indexOf('assets') > -1 || url.indexOf('blob:') > -1 || url.indexOf('http') == 0)
    return url;
  else if (/hk.kyoran.jp/.test(location.host))
    return '//hk.kyoran.jp/res/' + url;
  else
    return '//localhost/kyoran/api/public/res/' + url;
}

Vue.prototype.url1 = function (urls) {
  return Vue.prototype.url(urls.split(',')[0]);
}

Vue.prototype.thumb = function (url) {
  if (/hk.kyoran.jp/.test(location.host))
    return '//hk.kyoran.jp/res/' + url.replace('img/', 'thumb/');
  else
    return '//localhost/kyoran/api/public/res/' + url.replace('img/', 'thumb/');
}

Vue.prototype.thumb1 = function (urls) {
  return Vue.prototype.thumb(urls.split(',')[0]);
}

Vue.prototype.makeSort = function (sort) {
  let order = [];
  for (let key in sort) {
    if (sort[key] > 0)
      order.push(key + '-' + sort[key]);
  }
  return order.join(',');
}

Vue.prototype.sortToggle = function (sort, key) {

  let old = sort[key];

  let value;

  for (let _key in sort) {
    sort[_key] = 0;
  }

  if (old == 0)
    value = 2;
  else if (old == 1)
    value = 2;
  else if (old == 2)
    value = 1;

  sort[key] = value;

}

Vue.prototype.stopPropagation = function () {
  event.stopPropagation();
}

Vue.filter('number', function (num) {
  var suffix = '';

  num = Number(num);
  if (num.toString().indexOf('.') > -1) {
    suffix = '.' + num.toString().split('.')[1];
    num = num.toString().split('.')[0];
  }
  var result = [],
    counter = 0;
  num = (num || 0).toString().split('');
  for (var i = num.length - 1; i >= 0; i--) {
    counter++;
    result.unshift(num[i]);
    if (!(counter % 3) && i != 0) {
      result.unshift(',');
    }
  }
  return result.join('') + suffix;
});

Vue.filter('friendly', function (date) {
  var d = new Date(date);
  return d.format('MM/dd hh:mm');
});

Vue.filter('friendly2', function (date) {
  return date.replace(':', '时') + '分';
});

Vue.filter('friendly3', function (date) {
  return new Date(date).format('MM月dd日');
});

Vue.filter('plainText', function (html) {
  if (!html) return '';
  var d = document.createElement("div");
  d.innerHTML = html;
  return d.innerText;
});

Vue.filter('n', function (number) {
  return Number(number);
});

Vue.filter('d', function (date) {
  if (!date)
    return '';
  return new Date(date).format('M/d hh:mm')
});

Vue.filter('d2', function (date) {
  if (!date)
    return '';
  return new Date(date).format('M/d')
});

Vue.filter('d3', function (date) {
  if (!date)
    return '';
  return new Date(date).format('h:s')
});

Vue.filter('d4', function (date) {
  if (!date)
    return '';
  return new Date(date).format('yyyy.MM.dd')
});

Vue.filter('d5', function (date) {
  if (!date)
    return '';
  return new Date(date).format('yyyy/MM/dd')
});

Vue.filter('d6', function (date) {
  if (!date)
    return '';
  return new Date(date).format('yyyy/MM')
});

Vue.filter('d7', function (date) {
  if (!date)
    return '';
  return new Date(date).format('MM/dd')
});

Vue.filter('d8', function (date) {
  if (!date)
    return '';
  return new Date(date).format('yyyy年MM月dd日')
});

Vue.filter('d9', function (date) {
  if (!date)
    return '';
  return new Date(date).format('M月d日')
});

Vue.filter('sn', function (id) {
  id = id.toString();
  if (id.length == 1)
    id = "00" + id;
  else if (id.length == 2)
    id = "0" + id;
  return 'KH-' + id;
});

Vue.filter('days', function (date) {
  return Math.ceil(((new Date()) - (new Date('2022-08-15 19:31:39'))) / (24 * 60 * 1000 * 60));
});

Vue.filter('firstline', function (text) {
  if (text) {
    return text.split("\n")[0];
  }
  return "";
});

Vue.filter('prevMonth', function (month) {
  month = Number(month);
  if (month == 1) {
    month = 12;
  }
  else
    month--;

  return month;
});

Vue.filter('nextMonth', function (month) {
  month = Number(month);
  if (month == 12) {
    month = 1;
  }
  else
    month++;

  return month;
});

Vue.prototype.pad2 = function (v) {
  if (Number(v) < 1)
    return v;
  v = v.toString();
  if (v.length == 1)
    return "0" + v;
  else
    return v;
}

Vue.filter('pad2', Vue.prototype.pad2);

Vue.prototype.dayIndex = function (date) {
  date = new Date(date);
  let arr = ['日', '月', '火', '水', '木', '金', '土'];

  return arr[date.getDay()];
}

Vue.filter('dayIndex', Vue.prototype.dayIndex);

Vue.prototype.hl = function (text, keywords) {
  if (text) {
    return text.replace(keywords, '<b class="tr">' + keywords + '</b>')
  }
  return "";
};

Vue.filter('hl', Vue.prototype.hl);

Vue.prototype.br = function (text) {
  if (text) {
    return text.replace(/\n/g, "<br>");
  }
  return "";
}
Vue.filter('br', Vue.prototype.br);

Vue.prototype.shortText = function (text, len) {
  len = len || 2;
  if (text.length > len + 1) {
    return text.substr(0, len) + '..' + text[text.length - 1];
  }
  return text;
}

Vue.filter('shortText', Vue.prototype.shortText);

Vue.filter('shortName', function (text, len, len2) {
  if (/^[a-zA-Z0-9]{1,}$/.test(text)) {
    return Vue.prototype.shortText(text, len2);
  }
  return Vue.prototype.shortText(text, len);

});

Vue.prototype.shortText2 = function (text, len, max) {

  text = text.trim();
  len = len || 2;
  max = max || 4;
  if (text.length > max) {
    return text.substr(0, len) + '..';
  }
  return text;
}

Vue.filter('shortText2', Vue.prototype.shortText2);

Vue.prototype.shortText3 = function (text, len) {

  text = text.trim();
  len = len || 2;
  if (text.length > len) {
    return text.substr(0, len) + '..';
  }
  return text;
}

Vue.filter('shortText3', Vue.prototype.shortText3);

Vue.prototype.shortText4 = function (text, len) {

  text = text.trim();
  len = len || 2;
  if (text.length > len) {
    return text.substr(0, len) + '...';
  }
  return text;
}

Vue.filter('shortText4', Vue.prototype.shortText4);

Vue.prototype.t = function (v) {
  if (window._i18n[window._language][v])
    return window._i18n[window._language][v];
  else
    return v;
}

Vue.prototype.minutesText = function (minutes) {

  // 计算小时和剩余分钟
  const hours = Math.floor(minutes / 60); // 获取完整的小时数
  const remainingMinutes = minutes % 60; // 获取剩余的分钟数

  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(remainingMinutes).padStart(2, '0');

  return formattedHours + 'h' + formattedMinutes + 'm';
}

Vue.prototype.friendlyTime = function (date, lang) {
  const now = new Date();
  const inputTime = new Date(date);

  // 计算时间差（单位：毫秒）
  const diffInMs = Math.abs(now - inputTime);

  // 换算成分钟
  const diffInMinutes = Math.floor(diffInMs / 1000 / 60);

  if (diffInMinutes > 60) {
    if (now.format('yyyyMMdd') == inputTime.format('yyyyMMdd')) {
      return inputTime.format('hh:mm');
    }
    else {
      return inputTime.format('MM/dd hh:mm');
    }
  }
  else if (diffInMinutes < 2) {
    return {
      'none': '只今',
      'jp': '只今',
      'cn': '刚刚',
      'en': 'A few seconds',
    }[lang];
  }
  else {
    let suffix = {
      'none': ' 分前',
      'jp': ' 分前',
      'cn': ' 分前',
      'en': ' min ago',
    }[lang];
    return diffInMinutes + suffix;
  }
}

Vue.filter('friendlyTime', Vue.prototype.friendlyTime);

Vue.prototype.getMondayOfThisWeek = function (date) {
  date = date ? date : Date.today();
  let dayOfWeek = date.getDay();
  let diff = date.getDate() - dayOfWeek + (dayOfWeek == 0 ? -6 : 1); // 调整当今天是周日的情况
  return new Date(date.setDate(diff));
}

Vue.prototype.calcDateDiffDays = function (dateString1, dateString2) {
  // 将日期字符串转换为 Date 对象
  const date1 = new Date(dateString1);
  const date2 = new Date(dateString2);

  // 将时间戳转换为毫秒，并计算天数差
  const timeDifference = date2 - date1;
  const dayDifference = timeDifference / (1000 * 60 * 60 * 24);

  return dayDifference;
}

Vue.prototype.initSocket = function () {

  let t = this;

  let sok = new WebSocket(t.wsURL);

  const HEARTBEAT_INTERVAL = 10000;

  let heartbeatIntervalId;

  let sendHeartbeat = window.sendHeartbeat = function () {
    sok.send(JSON.stringify({ heartbeat: true }));
  }

  sok.addEventListener('open', function (event) {
    console.log('socket is open');
    sendHeartbeat();
    heartbeatIntervalId = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);
  });

  sok.addEventListener('message', function (event) {
    t.receiveMessage(event);
  });

  sok.onclose = function () {
    clearInterval(heartbeatIntervalId);
  };

  window.sok = sok;
}

Vue.prototype.sendMessage = function (extras) {

  let t = this;

  let sok = window.sok;

  if (sok && sok.readyState === WebSocket.OPEN) {
    sok.send(JSON.stringify({
      event: 'room_sync',
      extras: extras
    }));
  }
  else {

    clearInterval(window.connectSocketTimer);
    t.initSocket();
    sok = window.sok;
    window.connectSocketTimer = setInterval(() => {
      if (sok && sok.readyState === WebSocket.OPEN) {
        sok.send(JSON.stringify({
          event: 'room_sync',
          extras: extras
        }));
        clearInterval(window.connectSocketTimer);
      }
    }, 50);

  }
}

Vue.directive('longpress', {
  bind: function (el, binding, vnode) {
    let timer = null;
    let stop = false;

    el.addEventListener('touchstart', () => {
      // 设置一个定时器模拟长按
      if (timer) {
        return;
      }
      timer = setTimeout(() => {
        timer = null;
        if (binding.value) {
          stop = true;
          binding.value(); // 执行传入的方法
        }
      }, 800); // 长按时间设置为1秒
    });

    el.addEventListener('touchend', () => {
      clearTimeout(timer); // 手指松开清除定时器
    });

    // 可选：添加 mouse 支持（用于 PC 端）
    el.addEventListener('mousedown', () => {
      if (timer) {
        return;
      }
      timer = setTimeout(() => {
        timer = null;
        if (binding.value) {
          stop = true;
          binding.value();
        }
      }, 800);
    });

    el.addEventListener('mouseup', () => {
      clearTimeout(timer);
      if (stop) {
        event.stopPropagation();
        event.preventDefault();
      }
    });

    el.addEventListener('mouseleave', () => {
      clearTimeout(timer);
      if (stop) {
        event.stopPropagation();
        event.preventDefault();
      }
    });
  }
});

Vue.prototype.$eventBus = new Vue();

new Vue({
  render: h => h(Index),
  eventHub: new Vue(),
  router
}).$mount('#app');

if (/KIS-iOS/.test(window.navigator.userAgent)) {
  document.body.classList.add('platform-ios');
  document.body.classList.add('platform-app');
}
else if (/iPhone/.test(window.navigator.userAgent)) {
  document.body.classList.add('platform-ios');
}
else {
  document.body.classList.add('platform-android');
}

(function enhanceImagePreviewNav() {
  var svgPrev = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>';
  var svgNext = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>';

  function isPC() {
    return document.body.classList.contains('pc') ||
      !/Android|iPhone|iPad|iPod|Mobile|KIS-iOS/i.test(navigator.userAgent);
  }

  function getPreviewVm(el) {
    var vm = el.__vue__;
    while (vm) {
      if (vm.$refs && vm.$refs.swipe && typeof vm.swipeTo === 'function') {
        return vm;
      }
      vm = vm.$parent;
    }
    return null;
  }

  function stopBubble(e) {
    e.stopPropagation();
  }

  function addNav(previewEl, retry) {
    if (!isPC()) {
      return;
    }
    if (previewEl.querySelector('.van-image-preview__nav')) {
      return;
    }
    var vm = getPreviewVm(previewEl);
    if (!vm) {
      if ((retry || 0) < 10) {
        setTimeout(function () {
          addNav(previewEl, (retry || 0) + 1);
        }, 50);
      }
      return;
    }
    if (!vm.images || vm.images.length < 2) {
      return;
    }

    function makeBtn(dir) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'van-image-preview__nav van-image-preview__nav--' + dir;
      btn.innerHTML = dir === 'prev' ? svgPrev : svgNext;
      btn.addEventListener('touchstart', stopBubble);
      btn.addEventListener('touchend', stopBubble);
      btn.addEventListener('mousedown', stopBubble);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (vm.$refs.swipe) {
          if (dir === 'prev') {
            vm.$refs.swipe.prev();
          } else {
            vm.$refs.swipe.next();
          }
        }
      });
      return btn;
    }

    previewEl.appendChild(makeBtn('prev'));
    previewEl.appendChild(makeBtn('next'));
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }
    if (root.classList && root.classList.contains('van-image-preview')) {
      addNav(root);
    }
    var nodes = root.querySelectorAll('.van-image-preview');
    for (var i = 0; i < nodes.length; i++) {
      addNav(nodes[i]);
    }
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        scan(added[j]);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  function getActivePreviewVm() {
    var nodes = document.querySelectorAll('.van-image-preview');
    for (var i = nodes.length - 1; i >= 0; i--) {
      var vm = getPreviewVm(nodes[i]);
      if (vm && vm.$refs && vm.$refs.swipe) {
        return vm;
      }
    }
    return null;
  }

  document.addEventListener('keydown', function (e) {
    if (!isPC()) {
      return;
    }
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
      return;
    }
    var tag = (e.target && e.target.tagName) || '';
    if (tag === 'INPUT' || tag === 'TEXTAREA' || (e.target && e.target.isContentEditable)) {
      return;
    }
    var vm = getActivePreviewVm();
    if (!vm || !vm.images || vm.images.length < 2) {
      return;
    }
    e.preventDefault();
    if (e.key === 'ArrowLeft') {
      vm.$refs.swipe.prev();
    } else {
      vm.$refs.swipe.next();
    }
  });
})();

window.locationSuccess = function (data) { console.log(data); }

window.locationFail = function (err) { console.log(err); }

window.buildURLParams = function (obj) {

  var items = [];

  for (var name in obj) {
    items.push(name + '=' + encodeURIComponent(obj[name]));
  }
  return items.join('&');
}

window.blendTransparentColor = function (hex, alpha = 0.65) {

  const backgroundRGB = [255, 255, 255];

  const cleaned = hex.replace(/^#/, '');

  // 分割成两两一组
  const fr = parseInt(cleaned.slice(0, 2), 16); // FC → 252
  const fg = parseInt(cleaned.slice(2, 4), 16); // A0 → 160
  const fb = parseInt(cleaned.slice(4, 6), 16); // 00 → 0
  const [br, bg, bb] = backgroundRGB;

  const r = Math.round(alpha * fr + (1 - alpha) * br);
  const g = Math.round(alpha * fg + (1 - alpha) * bg);
  const b = Math.round(alpha * fb + (1 - alpha) * bb);

  return `rgb(${r}, ${g}, ${b})`;
}

/**
* 计算两个时间点之间的深夜工作时长（单位：小时）
* 深夜定义为当天晚上22:00:00到次日早上05:00:00。
* 此函数将累计所有日期中在22:00-24:00以及00:00-06:00时间段内的工作时长。
* @param {Date} start - 开始时间的Date对象
* @param {Date} end - 结束时间的Date对象
* @returns {number} 深夜工作时长，单位为小时，精确到小数点后两位
*/
window.calculateOvernightHours = function (start, end) {

  // 确保结束时间晚于开始时间
  if (end < start) {
    let t = end;
    end = start;
    start = t;
  }

  // 深夜时间段的开始和结束（小时）
  const OVERNIGHT_START_HOUR = 22; // 晚上10点
  const OVERNIGHT_END_HOUR = 5;    // 凌晨6点

  let totalOvernightSeconds = 0;
  let current = new Date(start); // 使用一个临时变量遍历时间区间

  // 遍历从start到end的每一天
  while (current < end) {
    // 获取当前日期的开始（00:00:00）
    const dayStart = new Date(current.getFullYear(), current.getMonth(), current.getDate());
    // 获取当前日期的结束（23:59:59）
    const dayEnd = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 1);
    dayEnd.setSeconds(-1); // 精确到23:59:59

    // 确定本次计算的有效时间段（不能超过整个遍历区间）
    const periodStart = new Date(Math.max(current.getTime(), start.getTime()));
    const periodEnd = new Date(Math.min(dayEnd.getTime(), end.getTime()));

    // --- 计算当前日期的深夜时段 ---
    // 1. 计算晚上22:00:00到23:59:59的时段
    const nightStart = new Date(dayStart);
    nightStart.setHours(OVERNIGHT_START_HOUR, 0, 0, 0); // 当天22:00:00

    // 如果当前日期是最后一天，且结束时间早于当天22点，则跳过
    if (periodEnd >= nightStart) {
      const nightEnd = new Date(dayStart);
      nightEnd.setHours(24, 0, 0, 0); // 当天24:00:00 (即第二天00:00:00)

      // 计算实际的深夜时段交集
      const overlapStart = new Date(Math.max(periodStart.getTime(), nightStart.getTime()));
      const overlapEnd = new Date(Math.min(periodEnd.getTime(), nightEnd.getTime()));

      if (overlapEnd > overlapStart) {
        totalOvernightSeconds += (overlapEnd.getTime() - overlapStart.getTime()) / 1000;
      }
    }

    // 2. 计算次日00:00:00到06:00:00的时段
    const dawnStart = new Date(dayStart);
    dawnStart.setHours(0, 0, 0, 0); // 次日00:00:00 (即当天的0点)
    const dawnEnd = new Date(dayStart);
    dawnEnd.setHours(OVERNIGHT_END_HOUR, 0, 0, 0); // 次日06:00:00

    // 检查这个凌晨时段是否在有效的遍历区间内
    if (periodStart < dawnEnd && periodEnd > dawnStart) {
      // 计算实际的凌晨时段交集
      const overlapStart = new Date(Math.max(periodStart.getTime(), dawnStart.getTime()));
      const overlapEnd = new Date(Math.min(periodEnd.getTime(), dawnEnd.getTime()));

      if (overlapEnd > overlapStart) {
        totalOvernightSeconds += (overlapEnd.getTime() - overlapStart.getTime()) / 1000;
      }
    }

    // 进入下一天
    current.setDate(current.getDate() + 1);
  }

  // 将总秒数转换为小时数
  const hours = totalOvernightSeconds / 3600;
  // 保留两位小数
  return Math.round(hours * 100) / 100;
}

/**
 * 压缩图片 Blob
 * @param {Blob} originalBlob - 原始图片的 Blob 对象
 * @returns {Promise<Blob>} 压缩后的 Blob
 */
window.compressImageBlob = function (originalBlob, quality) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // 设置图片加载完成后的处理
    image.onload = () => {
      // 设置 canvas 尺寸为图片原始尺寸（也可在此做缩放）
      canvas.width = image.width;
      canvas.height = image.height;

      // 清除画布并绘制图片
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0);

      // 将 canvas 转为压缩后的 Blob（质量 0.7 = 70%）
      canvas.toBlob(
        (compressedBlob) => {
          if (compressedBlob) {
            resolve(compressedBlob);
          } else {
            reject(new Error('Canvas 转 Blob 失败'));
          }
        },
        'image/jpeg', // 强制输出为 jpeg（可改为 image/webp 等）
        quality || 0.7          // 压缩质量（0 ~ 1）
      );
    };

    image.onerror = () => {
      reject(new Error('图片加载失败'));
    };

    // 为跨域图片安全起见，可选设置（若图片来自同源或允许 CORS 可不设）
    // image.crossOrigin = 'anonymous';

    // 使用 Blob URL 加载图片
    image.src = URL.createObjectURL(originalBlob);
  });
}

$(document).delegate('input,div[contenteditable="true"],textarea', 'focus', function () {
  document.body.classList.add('typing');
});

$(document).delegate('input,div[contenteditable="true"],textarea', 'blur', function () {
  setTimeout(function () {
    document.body.classList.remove('typing');
  }, 20);
});

document.addEventListener('touchend', function (e) {
  // 如果点击的不是输入框或文本域，就让当前聚焦的元素失去焦点
  if (!e.target.matches('input, textarea, [contenteditable="true"]')) {
    const active = document.activeElement;
    if (active && active.tagName === 'INPUT' || active.tagName === 'TEXTAREA') {
      active.blur();
      dismissKeyboard(active);
    }
  }
});

function dismissKeyboard(element) {
  element.setAttribute('readonly', 'readonly');
  element.blur();
  setTimeout(() => {
    element.removeAttribute('readonly');
  }, 0);
}